<template>
    <div>
      <v-data-table :headers="colunasValidas" :items="itensReajuste" hide-actions
                    class="az-table-list tabela-itens-reajuste"
                    no-data-text="Não há itens cadastrados"
                    ref="dTable">
        <template slot="items" slot-scope="props" class="hover-linha">
          <tr class="linha-info">
            <td>
                    <span v-if="props.item.sequencia">
                        {{ props.item.sequencia | azNumber }}
                    </span>
              <span v-else>&nbsp;-&nbsp;</span>
            </td>
            <td>
              <expansao-texto :tamanho="tamanho" :texto="props.item.descricao"/>
            </td>
            <td>
              {{ props.item.unidade }}
            </td>
            <td>
              {{ props.item.modelo }}
            </td>
            <td>
              {{ props.item.marca }}
            </td>
            <td align="right">
                    <span v-if="props.item.quantidade">
                        {{ props.item.quantidade | cdCurrency('', qtdeCasasDecimais(casasDecimaisQuantidade)) }}
                    </span>
              <span v-else>&nbsp;-&nbsp;</span>
            </td>
            <td align="right" :class="tacharTextoCondicionalmente(props.item)">
                 {{props.item.valorUnitarioInicial | cdCurrency(prefix, casasDecimais)}}{{suffix}}
            </td>
            <td align="right">
              <campo-monetario
                  :name="'valorUnitárioReajustado' + props.item.valorUnitarioReajustado"
                  v-model="props.item.valorUnitarioReajustado"
                  @blur="salvarValor($event, props.item)"
                  placeholder="Valor"
                  :precision="casasDecimais"
                  :maxLength="18"
                  :required="true"
                  :prefix="prefix"
                  :suffix="suffix"
                  :disabled="regrasDesabilitado"
                  v-validate="'required'"
                  class="alinhar-direita input-reajuste"
                  :showClearButton="false"/>
              <span class="mensagem-erro" v-if="props.item.valorUnitarioReajustado === null">
                        Obrigatório
                    </span>
            </td>
            <td align="right" v-if="!isCriterioJulgamentoMaiorDesconto">
                    <span v-if="props.item.valorTotal !== null">
                        {{ props.item.valorTotal | cdCurrency(prefix, casasDecimais)}}{{suffix}}
                    </span>
              <span v-else>&nbsp;-&nbsp;</span>
            </td>
          </tr>
        </template>
      </v-data-table>
      <div class="botao-enviar-proposta"
           v-show="deveExibirEnvioReajuste()">
          <a slot="activator">
            <v-btn
                id="btn-enviar-reajuste"
                color="primary"
                outline
                @click="exibirDialogoConfirmacao"
                flat>
              Confirmar Valor
            </v-btn>
          </a>
      </div>
    </div>
</template>

<script>

export default {
    name: 'PainelLoteTabela',
    props: {
        itensReajuste:{
            type: Array,
            default: () => {
                return []
            }
        },
        situacaoReajusteLote: {
            type: String,
            default: null
        },
        casasDecimais: {
            type: Number,
            default: 2
        },
        criterioJulgamento:{
            type: String
        },
        simboloCriterioJulgamento:{
            type: String
        },
        validarLancesPor:{
            type: String
        },
        prefixSuffixValor:{
            type: String
        },
        isCriterioJulgamentoMaiorDesconto:{
            type: Boolean,
            default: false
        },
        casasDecimaisQuantidade: {
            type: Number,
            default: 2
        }
    },
    $_veeValidate: {
        validator: 'new'
    },
    data() {
        return {
            tamanho: null,
            colunas: [
                {
                    text: 'Seq',
                    value: 'sequencia',
                    align: 'left',
                    sortable: false,
                    width: '5%',
                    class: 'primary--text',
                },
                {
                    text: 'Descrição',
                    value: 'descricao',
                    align: 'left',
                    sortable: false,
                    width: '20%',
                    class: 'primary--text',
                },
                {
                    text: 'Unidade',
                    value: 'unidade',
                    sortable: false,
                    align: 'left',
                    width: '8%',
                    class: 'primary--text'
                },
                {
                    text: 'Modelo',
                    value: 'modelo',
                    sortable: false,
                    align: 'left',
                    width: '10%',
                    class: 'primary--text'
                },
                {
                    text: 'Marca',
                    value: 'marca',
                    sortable: false,
                    align: 'left',
                    width: '15%',
                    class: 'primary--text'
                },
                {
                    text: 'Qtd',
                    value: 'quantidade',
                    align: 'right',
                    sortable: false,
                    width: '5%',
                    class: 'primary--text'
                },
                {
                    text: this.isCriterioJulgamentoMaiorDesconto ? 'Desconto Inicial' : 'Valor Unit. Inicial',
                    value: 'valorPropostaInicial',
                    sortable: false,
                    align: 'right',
                    width: '12%',
                    class: 'primary--text'
                },
                {
                    text: this.isCriterioJulgamentoMaiorDesconto ? 'Desconto' : 'Valor Unitário',
                    value: 'valorReajustado',
                    sortable: false,
                    align: 'right',
                    width: '13%',
                    class: 'primary--text'
                },
                {
                    text: 'Valor Total',
                    value: 'valorTotal',
                    sortable: false,
                    align: 'right',
                    width: '12%',
                    class: 'primary--text'
                }
            ]
        }
    },
    computed:{
        colunasValidas(){
            if(this.isCriterioJulgamentoMaiorDesconto)
                return this.colunas.filter(coluna => coluna.text !== 'Valor Total')
            return this.colunas
        },
        prefix(){
            return this.prefixSuffixValor === 'R$' ? 'R$ ' : ''
        },
        suffix(){
            return this.prefixSuffixValor === '%' ? '%' : ''
        },
        regrasDesabilitado() {
            if(this.isCriterioJulgamentoMaiorDesconto)
                return true
            return this.situacaoReajusteLote === 'FINALIZADO' || this.situacaoReajusteLote === 'REABERTO_NEGOCIACAO'
        }
    },
    created() {
        window.addEventListener('resize', this.pegarTamanho)
        this.pegarTamanho()
    },
    methods: {
        salvarValor(novoValor, item) {
            item.valorUnitarioReajustado = novoValor
            this.$emit('salvarItem', item)
        },
        pegarTamanho() {
            this.tamanho = .03 * window.innerWidth
        },
        tacharTextoCondicionalmente({valorUnitarioInicial, valorUnitarioReajustado}) {
            if(valorUnitarioInicial !== null && valorUnitarioInicial !== valorUnitarioReajustado)
                return 'tachado'
            return ''
        },
        exibirDialogoConfirmacao() {
            this.$emit('exibirDialogoConfirmacao')
        },
        deveExibirEnvioReajuste() {
            return this.situacaoReajusteLote !== 'FINALIZADO' &&
              this.situacaoReajusteLote !== 'REABERTO_NEGOCIACAO'
        }
    },
    destroyed() {
        window.removeEventListener('resize', this.pegarTamanho)
    }
}
</script>

<style scoped lang="stylus">
    .input-reajuste
        padding-top 0

    .tachado
        text-decoration line-through

    .linha-info
        border-bottom 0 !important

    .tabela-itens-reajuste
        padding 16px 16px 0

        tr
            border-bottom 1px solid #e7e7e7 !important

        thead tr th
            padding 5px 10px !important
            font-weight bold

        .v-datatable__expand-col
            border-bottom 1px solid #ddd
            padding-top 0 !important

    .botao-enviar-proposta
      text-align right

    @media (max-width 720px)
        .tabela-itens-reajuste
            padding 0

            td:nth-of-type(1):before
                content "Sequência:"

            td:nth-of-type(2):before
                content "Descrição:"

            td:nth-of-type(3):before
                content "Unidade:"

            td:nth-of-type(4):before
                content "Modelo:"

            td:nth-of-type(5):before
                content "Marca:"

            td:nth-of-type(6):before
                content "Quantidade:"

            td:nth-of-type(7):before
                content "Valor Unitário:"

            td:nth-of-type(8):before
                content "Reajustar Valor Unitário:"

            td:nth-of-type(9):before
                content "Valor Total:"

            td:nth-of-type(6)
                text-align left

            td:nth-of-type(7)
                text-align left

            td:nth-of-type(8)
                text-align left

            td:nth-of-type(9)
                text-align left
</style>